import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
//import { useNavigate } from 'react-router-dom';
import Spinner from '@/common/Spinner';
import styles from './Authenticate.module.scss';
import { appVersion } from '@/utils';

function Authenticate() {
  //const navigate = useNavigate();

  //connect to the server to see if the service worker has been refreshed
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW() {
      return;
    },
  });

  useEffect(() => {
    //logic to refresh tables
    const asyncProcess = async () => {
      // await table refresh....

      if (needRefresh) {
        (async () => {
          setNeedRefresh(false);
          await updateServiceWorker(true);
        })();
      }
    };

    asyncProcess();
  }, [needRefresh]);

  return (
    <div className={styles.body}>
      <span className={styles.content}>
        Loading latest club data
        <Spinner />
        <span>{appVersion}</span>
      </span>
    </div>
  );
}

export default Authenticate;
